import { makeStyles } from '@material-ui/core/styles'
import { Grid, Theme } from '@material-ui/core'
import { SemiConfigFormValues } from '../../ProductsConfiguration'
import ResponsivePagination from '@src/components/ResponsivePagination'
import { useFormikContext } from 'formik'
import useSearch from '../../useSearch'
import PageSelectDropDown from './PageSelectDropDown'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))
const Pagination = ({ totalCount }: { totalCount: number }) => {
  const formik = useFormikContext<SemiConfigFormValues>()
  const classes = useStyles()
  const { searchQuery } = useSearch()

  const numberOfPages =
    totalCount === parseInt(formik.values.searchData.count)
      ? 1
      : Math.ceil((totalCount || 10) / parseInt(formik.values.searchData.count))

  const handlePaginationClick = async (page: number) => {
    formik.setFieldValue('searchData.page', page, false)
    //trigger search
    await searchQuery({ page: page })
  }
  const handlePageChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const page = e.target.value as number
    handlePaginationClick(page)
  }
  return (
    <Grid container className={classes.container}>
      <ResponsivePagination
        loading={false}
        numPages={numberOfPages}
        currentPage={formik.values.searchData.page || 1}
        handleUpdatePage={handlePaginationClick}
        pageNumberElement={
          <PageSelectDropDown
            currentPage={formik.values.searchData.page || 1}
            handleChangePage={handlePageChange}
            numberOfPages={numberOfPages}
          />
        }
      />
    </Grid>
  )
}

export default Pagination
